export class SavePucaQuestionnaireModel {
	configScholarshipId: number;
	commonProfileId: number = null;
	exactName: String = '';
	isAdmissionAttained: boolean = false;
	isScholarshipAvailing: boolean = false;
	proposedFieldOfStudy: String = '';
	isFacultyResearcher: boolean = false;
	areaOfResearchId?: number;
	employment: String = '';
	age: String = '';
	pucaPreferencesDtoList?: pucaPreferencesModel[] = [];
	pucaGreDtoList?: any;
	pucaHatDtoList?: any;
	categoryTypeId?: any;
	isGre?: any;
	isHat?: any;
}
export class pucaPreferencesModel {
	universityId?: String;
	department: String = '';
	semesterId: String = '';
	semesterYear: String = '';
}

export class pucaGreModel {
	date: String = '';
	verbalScore: number = null;
	quantitativeScore: number = null;
	analyticalScore: number = null;
}


export class pucaHatModel {
	testDate: String = '';
	registrationNumber: String = '';
	totalScore: number = null;
	obtainedScore: number = null;
	percentage: number = null;
}
